import _ from 'lodash';

import { vNum } from '../utils/validateUtils';
import {
  SS_AUTH_VALIDATION_RETRY_COUNT,
  SS_RETRY_RELOAD_COUNT,
} from '../constants/sessionStorage';

/**
 * SessionStorageから値を取り出す
 * @param key キー
 * @returns 取り出した値。キーに紐づく値が存在しない場合はnullを返す。
 */
export function getItem<T>(key: string): T | null {
  const jsonString = sessionStorage.getItem(key);

  return jsonString === null ? null : JSON.parse(jsonString);
}

/**
 * SessionStorageに値を保存する
 * @param key キー
 * @param value JSON文字列に変換可能なオブジェクト（関数が含まれていると型エラーになる）
 */
export function setItem<T>(key: string, value: T): void {
  const jsonString = JSON.stringify(value);

  sessionStorage.setItem(key, jsonString);
}

/**
 * SessionStorageからキー、値を削除する
 * @param key キー
 */
export function removeItem(key: string) {
  sessionStorage.removeItem(key);
}

/**
 * SessionStorageからキー、値を全て削除する
 * @param key キー
 */
export function clearAllItem() {
  sessionStorage.clear();
}

/**
 * ログイン失敗時にリダイレクト回数のセット用関数
 **/
export const setSsAuthValidateRetryCount = (count: number) => {
  sessionStorage.setItem(SS_AUTH_VALIDATION_RETRY_COUNT, String(count));
};

/**
 * ログイン失敗時にリダイレクト回数の取得用関数
 **/
export const getSsAuthValidateRetryCount = () => {
  const retryCount = vNum.safeParse(
    sessionStorage.getItem(SS_AUTH_VALIDATION_RETRY_COUNT)
  );
  if (retryCount.success) {
    return _.parseInt(retryCount.data);
  }
  return 0;
};

/**
 * リフレッシュトークンの取得に失敗した回数のセット用関数
 **/
export const setSsRetryReloadCount = (count: number) => {
  sessionStorage.setItem(SS_RETRY_RELOAD_COUNT, String(count));
};

/**
 * リフレッシュトークンの取得に失敗した回数の取得用関数
 **/
export const getSsRetryReloadCount = () => {
  return sessionStorage.getItem(SS_RETRY_RELOAD_COUNT);
};
